export { default } from './event-card';
